import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const CreateTicket = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        title: '',
        message: '',
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('accessToken');

        if (!formData.title || !formData.message) {
            toast.warn('Please fill in all fields');
            return;
        }

        try {
            setLoading(true);
            const res = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/user-tickets`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            toast.success('Ticket created successfully!');
            navigate('/dashboard/ticket');
        } catch (error) {
            console.error('Ticket creation failed:', error);
            toast.error('Failed to create ticket');
        } finally {
            setLoading(false);
        }
    };

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <div className="max-w-2xl mx-auto p-6 border shadow rounded">
            <div className="flex justify-between items-center mb-4 border-b pb-3">
                <div>
                    <h1 className="text-lg font-semibold">Create Ticket</h1>
                    <p className="text-sm text-gray-500">Raise ticket for support</p>
                </div>
                <button
                    onClick={handleBackClick}
                    className="px-4 py-1 rounded-md text-white bg-black hover:bg-gray-800"
                >
                    Back
                </button>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="block text-sm mb-1">Title</label>
                    <input
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        className="w-full border px-3 py-2 rounded"
                        placeholder="Enter ticket title"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-sm mb-1">message</label>
                    <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        className="w-full border px-3 py-2 rounded"
                        rows={4}
                        placeholder="Describe your issue"
                    />
                </div>
                <button
                    type="submit"
                    disabled={loading}
                    className="btn-primary-sm"
                >
                    {loading ? 'Submitting...' : 'Submit Ticket'}
                </button>
            </form>
        </div>
    );
}

export default CreateTicket